import React, { Fragment } from 'react';
import { Card, Heading, Loading } from '../core';
import { Table } from '../core/Table';
import { Stats } from '../Stats';
import {
  getCustomVaultName,
  secDuration,
  useVaultPageSubgraph,
  formatPercentageBN,
  IStratInfo,
} from '@sc1/common';
import { useChain } from '@sc1/common/hooks';
import { ShortenedAddress } from '../ShortenedAddress';
import { PublicStrategyInfo } from './PublicStrategyInfo';

export const VaultInfo = ({
  strategies,
}: {
  strategies: IStratInfo[] | null;
}): JSX.Element => {
  const { loading, data } = useVaultPageSubgraph();
  const { name, id, owner, feePercent, underlying, underlyingSymbol } =
    data?.vault || {};
  const customName = getCustomVaultName(name);

  const chain = useChain();

  const { address: timelockAddress, minDelay } = data?.timelocks[0] || {};

  return (
    <>
      <Card>
        <Loading loading={loading}>
          <Heading as="h2">{customName}</Heading>
          <Stats data={data?.vault} chain={chain} />
          <Table
            mt={5}
            columns={[1, 2]}
            index={false}
            data={[
              ['Vault Contract', <ShortenedAddress key={id} address={id} />],
              [
                'Underlying Asset',
                <ShortenedAddress
                  key={underlying}
                  displayString={underlyingSymbol}
                  address={underlying}
                />,
              ],
              ['Vault Owner', <ShortenedAddress key={id} address={owner} />],
              [
                'Timelock Contract',
                <ShortenedAddress key={id} address={timelockAddress} />,
              ],
              ['Timelock Delay', secDuration(Number(minDelay))],
              ['Fee Percent', formatPercentageBN(feePercent, 18)],
            ]}
          />
        </Loading>
      </Card>
      {strategies &&
        strategies.map((strategy) => (
          <PublicStrategyInfo
            key={strategy.symbol}
            address={strategy.address}
          />
        ))}
    </>
  );
};
